/**
 * Events Section JavaScript
 * - Event list hover/click interaction
 * - Month navigation
 * - Countdown timer
 */

(function() {
  'use strict';

  // ===== Events Section - Main Interaction =====
  const initEventsSection = () => {
    const section = document.querySelector('.events-section');
    if (!section) return;

    const listContainer = section.querySelector('.js-events-list');
    const detailPanel = section.querySelector('.events-section__detail');

    // Sort event cards by start_date ascending
    if (listContainer) {
      var cardsArr = Array.from(listContainer.querySelectorAll('.events-section__event-card'));
      cardsArr.sort(function(a, b) {
        var dateA = a.dataset.startDate || '9999-99-99';
        var dateB = b.dataset.startDate || '9999-99-99';
        return dateA.localeCompare(dateB);
      });
      cardsArr.forEach(function(card) { listContainer.appendChild(card); });
      // Reset active class to first card
      cardsArr.forEach(function(card, i) { card.classList.toggle('active', i === 0); });
    }

    const eventCards = section.querySelectorAll('.events-section__event-card');

    if (!detailPanel || eventCards.length === 0) return;

    // Get detail panel elements
    const detailCategory = detailPanel.querySelector('.js-detail-category');
    const detailBgImage = detailPanel.querySelector('.js-detail-bg');
    const detailBgPlaceholder = detailPanel.querySelector('.js-detail-bg-placeholder');
    const detailBrand = detailPanel.querySelector('.js-detail-brand');
    const detailName = detailPanel.querySelector('.js-detail-name');
    const detailPrice = detailPanel.querySelector('.js-detail-price');
    const detailDate = detailPanel.querySelector('.js-detail-date');
    const detailLocation = detailPanel.querySelector('.js-detail-location');
    const detailBtn = detailPanel.querySelector('.js-detail-btn');
    const countdown = detailPanel.querySelector('.js-release-countdown');

    let currentIndex = 0;

    // Format date for display (YYYY-MM-DD -> MM.DD.YYYY)
    const formatDate = (dateStr) => {
      if (!dateStr) return 'TBD';
      const parts = dateStr.split('-');
      if (parts.length !== 3) return dateStr;
      return `${parts[1]}.${parts[2]}.${parts[0]}`;
    };

    // Format time (HH:MM -> H:MM AM/PM)
    const formatTime = (timeStr) => {
      if (!timeStr) return '';
      const parts = timeStr.split(':');
      if (parts.length !== 2) return timeStr;
      let hours = parseInt(parts[0]);
      const minutes = parts[1];
      const ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12 || 12;
      return `${hours}:${minutes} ${ampm}`;
    };

    // Get location label from value
    const getLocationLabel = (value) => {
      switch (value) {
        case 'online': return 'Online';
        case 'offline': return 'Offline';
        case 'both': return 'Online / Offline';
        default: return value || 'TBD';
      }
    };

    // Update countdown timer
    const updateCountdown = (startDate, startTime, timezone) => {
      if (!countdown) return;

      const daysEl = countdown.querySelector('.events-countdown__days');
      const hoursEl = countdown.querySelector('.events-countdown__hours');
      const minutesEl = countdown.querySelector('.events-countdown__minutes');
      const secondsEl = countdown.querySelector('.events-countdown__seconds');

      if (!daysEl || !hoursEl || !minutesEl || !secondsEl) return;

      if (!startDate || !startTime) {
        daysEl.textContent = '--';
        hoursEl.textContent = '--';
        minutesEl.textContent = '--';
        secondsEl.textContent = '--';
        return;
      }

      // Update countdown data attributes
      countdown.dataset.date = startDate;
      countdown.dataset.time = startTime;
      if (timezone) countdown.dataset.timezone = timezone;

      const userTimeZone = parseInt(countdown.dataset.timezone) || 0;

      const now = new Date();
      const utcTime = now.getTime();
      const timezoneOffset = now.getTimezoneOffset();
      const offsetInMs = timezoneOffset * 60 * 1000;
      const targetTimezoneOffset = userTimeZone * 60;
      const targetOffsetInMs = targetTimezoneOffset * 60 * 1000;
      const targetTime = utcTime + offsetInMs + targetOffsetInMs;
      const targetDate = new Date(targetTime);

      const countdownDate = new Date(`${startDate}T${startTime}`);
      const distance = countdownDate.getTime() - targetDate.getTime();

      if (distance < 0) {
        daysEl.textContent = '00';
        hoursEl.textContent = '00';
        minutesEl.textContent = '00';
        secondsEl.textContent = '00';
        countdown.classList.add('expired');
        return;
      }

      countdown.classList.remove('expired');
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      daysEl.textContent = days < 10 ? '0' + days : days;
      hoursEl.textContent = hours < 10 ? '0' + hours : hours;
      minutesEl.textContent = minutes < 10 ? '0' + minutes : minutes;
      secondsEl.textContent = seconds < 10 ? '0' + seconds : seconds;
    };

    // Select event by index
    const selectEvent = (index) => {
      if (index < 0 || index >= eventCards.length) return;

      currentIndex = index;
      const card = eventCards[index];

      // Update active state
      eventCards.forEach((c, i) => {
        c.classList.toggle('active', i === index);
      });

      // Scroll active card into view
      card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

      // Get event data from data attributes
      const data = card.dataset;

      // Update category
      if (detailCategory) {
        detailCategory.textContent = data.categoryLabel || 'EVENT';
        detailCategory.style.color = data.categoryColor || '#666';
      }

      // Update background image
      if (detailBgImage) {
        if (data.image) {
          detailBgImage.src = data.image;
          detailBgImage.alt = data.title || '';
          detailBgImage.style.display = '';
          if (detailBgPlaceholder) detailBgPlaceholder.style.display = 'none';
        } else {
          detailBgImage.style.display = 'none';
          if (detailBgPlaceholder) detailBgPlaceholder.style.display = '';
        }
      }

      // Update brand
      if (detailBrand) {
        detailBrand.textContent = data.brand || '';
        detailBrand.style.display = data.brand ? '' : 'none';
      }

      // Update product name
      if (detailName) {
        detailName.textContent = data.productName || data.title || '';
      }

      // Update price
      if (detailPrice) {
        detailPrice.textContent = data.price || '';
        detailPrice.style.display = data.price ? '' : 'none';
      }

      // Update date display
      if (detailDate) {
        const startDate = formatDate(data.startDate);
        const startTime = formatTime(data.startTime);
        const endDate = formatDate(data.endDate);
        const endTime = formatTime(data.endTime);
        const timezoneLabel = data.timezoneLabel || 'PST';

        let dateText = '';
        if (data.startDate && data.endDate && data.startDate !== data.endDate) {
          // Different dates: show range
          dateText = `${startDate} ${startTime} - ${endDate} ${endTime} ${timezoneLabel}`;
        } else if (data.startDate) {
          // Same date or single date
          if (startTime && endTime && startTime !== endTime) {
            dateText = `${startDate} ${startTime} - ${endTime} ${timezoneLabel}`;
          } else if (startTime) {
            dateText = `${startDate} @ ${startTime} ${timezoneLabel}`;
          } else {
            dateText = `${startDate} ${timezoneLabel}`;
          }
        } else {
          dateText = 'TBD';
        }

        // Update date text (find span inside)
        const dateSpan = detailDate.querySelector('span') || detailDate;
        if (dateSpan.tagName === 'SPAN') {
          dateSpan.textContent = dateText;
        } else {
          // If no span, update the last text node
          const textNodes = Array.from(detailDate.childNodes).filter(n => n.nodeType === 3);
          if (textNodes.length > 0) {
            textNodes[textNodes.length - 1].textContent = dateText;
          }
        }
      }

      // Update location
      if (detailLocation) {
        const locationLabel = getLocationLabel(data.location);
        const locationSpan = detailLocation.querySelector('span') || detailLocation;
        if (locationSpan.tagName === 'SPAN') {
          locationSpan.textContent = locationLabel;
        } else {
          const textNodes = Array.from(detailLocation.childNodes).filter(n => n.nodeType === 3);
          if (textNodes.length > 0) {
            textNodes[textNodes.length - 1].textContent = locationLabel;
          }
        }
      }

      // Update button link - hide if no link
      if (detailBtn) {
        if (data.link && data.link !== '#') {
          detailBtn.href = data.link;
          detailBtn.style.display = '';
        } else {
          detailBtn.style.display = 'none';
        }
      }

      // Update countdown
      updateCountdown(data.startDate, data.startTime, data.timezone);
    };

    // Event card click handlers
    eventCards.forEach((card, index) => {
      card.addEventListener('click', () => {
        selectEvent(index);
      });

      // Hover handler (optional - update on hover)
      card.addEventListener('mouseenter', () => {
        selectEvent(index);
      });
    });

    // Previous/Next event navigation buttons
    const prevEventBtn = section.querySelector('.js-event-prev');
    const nextEventBtn = section.querySelector('.js-event-next');

    if (prevEventBtn) {
      prevEventBtn.addEventListener('click', () => {
        // Find visible cards only
        const visibleCards = Array.from(eventCards).filter(card => card.style.display !== 'none');
        const currentVisibleIndex = visibleCards.findIndex(card => card.classList.contains('active'));
        if (currentVisibleIndex > 0) {
          const prevCard = visibleCards[currentVisibleIndex - 1];
          const prevIndex = Array.from(eventCards).indexOf(prevCard);
          selectEvent(prevIndex);
        }
      });
    }

    if (nextEventBtn) {
      nextEventBtn.addEventListener('click', () => {
        // Find visible cards only
        const visibleCards = Array.from(eventCards).filter(card => card.style.display !== 'none');
        const currentVisibleIndex = visibleCards.findIndex(card => card.classList.contains('active'));
        if (currentVisibleIndex < visibleCards.length - 1) {
          const nextCard = visibleCards[currentVisibleIndex + 1];
          const nextIndex = Array.from(eventCards).indexOf(nextCard);
          selectEvent(nextIndex);
        }
      });
    }

    // Initialize countdown timer interval
    if (countdown) {
      setInterval(() => {
        const activeCard = section.querySelector('.events-section__event-card.active');
        if (activeCard) {
          updateCountdown(
            activeCard.dataset.startDate,
            activeCard.dataset.startTime,
            activeCard.dataset.timezone
          );
        }
      }, 1000);
    }

    // Select first event by default
    if (eventCards.length > 0) {
      selectEvent(0);
    }
  };

  // ===== Month Navigation =====
  const initMonthNavigation = () => {
    const section = document.querySelector('.events-section');
    if (!section) return;

    const prevBtn = section.querySelector('.events-section__month-prev');
    const nextBtn = section.querySelector('.events-section__month-next');
    const monthLabel = section.querySelector('.js-month-label');

    if (!monthLabel) return;

    // Parse current month/year from label
    let currentDate = new Date();
    const labelText = monthLabel.textContent.trim();
    const match = labelText.match(/(\w+)\s+(\d{4})/);
    if (match) {
      const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
                          'July', 'August', 'September', 'October', 'November', 'December'];
      const monthIndex = monthNames.findIndex(m => m.toLowerCase() === match[1].toLowerCase());
      if (monthIndex !== -1) {
        currentDate = new Date(parseInt(match[2]), monthIndex, 1);
      }
    }

    const updateMonthLabel = () => {
      const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
                          'July', 'August', 'September', 'October', 'November', 'December'];
      monthLabel.textContent = `${monthNames[currentDate.getMonth()]} ${currentDate.getFullYear()}`;

      // Filter events by month (if events have month data)
      filterEventsByMonth(currentDate.getMonth(), currentDate.getFullYear());
    };

    const filterEventsByMonth = (month, year) => {
      const eventCards = section.querySelectorAll('.events-section__event-card');
      const emptyMsg = section.querySelector('.events-section__empty');
      const detailPanel = section.querySelector('.events-section__detail');
      let hasVisibleEvents = false;

      eventCards.forEach(card => {
        const startDate = card.dataset.startDate;
        if (startDate) {
          const eventDate = new Date(startDate);
          const selectedStart = new Date(year, month, 1);
          const isOnOrAfter = eventDate >= selectedStart;
          card.style.display = isOnOrAfter ? '' : 'none';
          if (isOnOrAfter) hasVisibleEvents = true;
        }
      });

      // Show/hide empty state
      const layoutEl = section.querySelector('.events-section__layout');
      const listWrapper = section.querySelector('.events-section__list-wrapper');
      if (emptyMsg) emptyMsg.style.display = hasVisibleEvents ? 'none' : '';
      if (detailPanel) detailPanel.style.display = hasVisibleEvents ? '' : 'none';
      if (listWrapper) listWrapper.style.gridColumn = hasVisibleEvents ? '' : '1 / -1';
      if (layoutEl) layoutEl.style.gridTemplateColumns = hasVisibleEvents ? '' : '1fr';

      // Select first visible event
      if (hasVisibleEvents) {
        const firstVisible = section.querySelector('.events-section__event-card:not([style*="display: none"])');
        if (firstVisible) firstVisible.click();
      }
    };

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        currentDate.setMonth(currentDate.getMonth() - 1);
        updateMonthLabel();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        currentDate.setMonth(currentDate.getMonth() + 1);
        updateMonthLabel();
      });
    }

    // Filter on initial load
    filterEventsByMonth(currentDate.getMonth(), currentDate.getFullYear());
  };

  // ===== Legacy Countdown Timer (for other sections) =====
  const initReleaseCountdown = () => {
    document.querySelectorAll('.js-release-countdown').forEach(countdown => {
      // Skip if already handled by events section
      if (countdown.closest('.events-section')) return;

      const daysEl = countdown.querySelector('.release-countdown__days') ||
                     countdown.querySelector('.events-countdown__days');
      const hoursEl = countdown.querySelector('.release-countdown__hours') ||
                      countdown.querySelector('.events-countdown__hours');
      const minutesEl = countdown.querySelector('.release-countdown__minutes') ||
                        countdown.querySelector('.events-countdown__minutes');
      const secondsEl = countdown.querySelector('.release-countdown__seconds') ||
                        countdown.querySelector('.events-countdown__seconds');

      if (!daysEl || !hoursEl || !minutesEl || !secondsEl) return;

      const updateCountdown = () => {
        const userDate = countdown.dataset.date;
        const userTime = countdown.dataset.time;
        const userTimeZone = parseInt(countdown.dataset.timezone) || 0;

        const now = new Date();
        const utcTime = now.getTime();
        const timezoneOffset = now.getTimezoneOffset();
        const offsetInMs = timezoneOffset * 60 * 1000;
        const targetTimezoneOffset = userTimeZone * 60;
        const targetOffsetInMs = targetTimezoneOffset * 60 * 1000;
        const targetTime = utcTime + offsetInMs + targetOffsetInMs;
        const targetDate = new Date(targetTime);

        const countdownDate = new Date(`${userDate}T${userTime}`);
        const distance = countdownDate.getTime() - targetDate.getTime();

        if (distance < 0) {
          daysEl.textContent = '00';
          hoursEl.textContent = '00';
          minutesEl.textContent = '00';
          secondsEl.textContent = '00';
          countdown.classList.add('expired');
          return;
        }

        countdown.classList.remove('expired');
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        daysEl.textContent = days < 10 ? '0' + days : days;
        hoursEl.textContent = hours < 10 ? '0' + hours : hours;
        minutesEl.textContent = minutes < 10 ? '0' + minutes : minutes;
        secondsEl.textContent = seconds < 10 ? '0' + seconds : seconds;
      };

      updateCountdown();
      setInterval(updateCountdown, 1000);
    });
  };

  // ===== Initialize =====
  const init = () => {
    initEventsSection();
    initMonthNavigation();
    initReleaseCountdown();
  };

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify section load
  document.addEventListener('shopify:section:load', init);

})();
